<template>
    <ul class="detail-files">
        <li v-for="file in filteredFiles" :key="file.name">
            <div v-if="file.type === 'directory'"class="directory">
                <div class="dir-title"  @click="toggle(file)" >
                    <span>{{ file.expanded ? '▼' : '▶' }}</span>
                    <span>{{ file.name }}</span>
                </div>
                <FileTree v-if="file.expanded" :files="file.children" :parentPath="file.parent" :deviceId="deviceId" />
            </div>
            <div v-else>
                <a :href="`/device-files/${deviceId}/${parentPath}/${file.name}`" target="_blank">{{ file.name }}</a>
            </div>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'FileTree',
    props: {
        files: Array,
        parentPath: String,
        deviceId: String
    },
    data() {
        return {
            fileSearch: '',
            filteredFiles: this.buildFileTree(this.files)
        };
    },
    watch: {
        files: {
            handler(newFiles) {
                this.filteredFiles = this.buildFileTree(newFiles);
            },
            immediate: true
        }
    },
    methods: {
        toggle(file) {
            file.expanded = !file.expanded;
            this.$forceUpdate(); // 强制刷新组件
        },
        filterFiles() {
            const search = this.fileSearch.toLowerCase();
            const filtered = this.files.filter(file => file.toLowerCase().includes(search));
            this.filteredFiles = this.buildFileTree(filtered);
        },
        buildFileTree(files) {
            console.log(files);

            const childrens = [];

            files.forEach(file => {
                const [dir, ...rest] = file.split('/');

                if (rest.length > 0) {
                    const ndir = childrens.find(child => child.name === dir);
                    const fname = file.substring(dir.length + 1);
                    if (ndir) {
                        ndir.children.push(fname);
                    } else {
                        childrens.push({
                            name: dir,
                            parent: `${this.parentPath}/${dir}`,
                            type: 'directory',
                            children: [fname],
                            expanded: false
                        });
                    }
                } else {
                    childrens.push({
                        name: dir,
                        type: 'file'
                    });
                }
            });

            console.log(childrens);

            return childrens;
        }
    }
}
</script>

<style scoped>
.detail-files {
    list-style: none;
    padding-left: 0;
    max-width: max-content;
    margin: 0 auto;
}

.directory {
    cursor: pointer;
}

.directory .dir-title {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
}

.directory span:first-child {
    margin-right: 5px;
}
</style>